import * as constants from "../constants/builder-menu";

export const openMenu = payload => ({
  type: constants.OPEN_MENU,
  payload: payload,
});

export const closeMenu = payload => ({ type: constants.CLOSE_MENU });
